import React, { useEffect, useState } from "react";
// FIXME: import assets
import defImage from "@3gaam/shared/assets/images/default-image.png";

type Props = {
  src: string | undefined;
  srcSet?: string | undefined;
  defSrc?: string | undefined;
  className?: string | undefined;
  alt?: string | undefined;
  style?: React.CSSProperties | undefined;
  title?: string | undefined;
};

const Image: React.FC<Props> = ({
  src,
  defSrc,
  className,
  alt,
  style,
  srcSet,
  title,
}) => {
  // FIXME: fix the type
  const [error, setError] = useState(false);
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    setImgSrc(src || defSrc || defImage);
  }, [src, defSrc]);

  const onError = () => {
    if (!error) {
      setImgSrc(defSrc || defImage);
      setError(true);
    }
  };

  return (
    <img
      src={imgSrc}
      srcSet={srcSet}
      className={className}
      alt={alt}
      onError={onError}
      style={style}
      itemProp="image"
      title={title}
    />
  );
};

export default React.memo(Image);
